import api from '@/services/api/notifications.js'
import { handleResponse } from '@/services/api/utils/response.js'

import { immerable } from "immer"
import { useState } from 'react'

class UseNotification {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.body = params.body
		this.title = params.title
		this.status = params.status
		this.event = params.event


		this.heading = params.heading
		this.message = params.message
		this.subscriptionId = params.subscriptionId
		this.useCaseId = params.useCaseId
		this.useCaseStatus = params.useCaseStatus

		this.image = params.image
		this.date = params.date
		this.action = params.action
		this.$selected = false
	}
}

const useUseNotification = () => {

	const [items, setItems] = useState([])
	const [meta, setMeta] = useState(null)
	const [currentItem ,setCurrentItem] = useState(null)
	const [loading, setLoadng] = useState(false)
	const [error, setError] = useState()

	async function fetch(parameter) {
		setLoadng(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoadng(false)

		if (error) {
			return setError(error)
		}

		const { meta } = data

		if (!Array.isArray(data.items)) {
			return setError('Notification is not an array')
		}
		handleResponse(data)
		const serializedData = data.items.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new UseNotification(params))

		setItems(newItems)
		setMeta(meta)
		return items
	}

	async function find(parameter) {
		setLoadng(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoadng(false)

		if (error) {
			return setError(error)
		}

		if (!Array.isArray(data.items)) {
			return setError('Notification is not an array')
		}

		const serializedData = data.items.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new UseNotification(params))

		return newItems
	}

	function serialize(entry) {
		return {
			id: entry.id,
			body: entry.body,
			title: entry.title,
			date: entry.created,
			status: entry.status,
			event: entry.event,




			action: entry.event,






			heading: entry.title,
			message: entry.body,

			subscriptionId : entry.body.subscriptionId,
			useCaseId : entry.body.useCaseId,
			useCaseStatus : entry.body.status,
			image: entry.body.image,
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		find,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		meta
	}

}

export default useUseNotification
